import { render, staticRenderFns } from "./ValidationData.vue?vue&type=template&id=4bc48f9a"
import script from "./ValidationData.vue?vue&type=script&lang=js"
export * from "./ValidationData.vue?vue&type=script&lang=js"
import style0 from "./ValidationData.vue?vue&type=style&index=0&id=4bc48f9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports